import { ReactElement, ReactNode } from 'react'
import { Box } from '@mui/material'

export interface StickyFooterProps {
  children: ReactNode
}

/**
 * Footer pinned to the bottom of a flex-column pane (doesn't shrink), with a top divider and a
 * light background. Children are stacked vertically. Used e.g. for the Results2 "Berechnen" footer
 * and the document manager footers.
 */
export const StickyFooter = ({ children }: StickyFooterProps): ReactElement => (
  <Box
    sx={{
      px: 1.5,
      pt: 1,
      pb: 1.25,
      pl: 2,
      borderTop: '1px solid',
      borderColor: 'divider',
      display: 'flex',
      flexDirection: 'column',
      gap: 1,
      background: '#FAFAFB',
      flexShrink: 0,
    }}
  >
    {children}
  </Box>
)
